// libs
import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Close } from '@lyearn/icons';
import { LinkButton, Tooltip } from '@lyearn/ui';
import { Stack } from '@lyearn/ui';
import ContentItem from '@/modules/corporate/modules/path/views/PathEditor/components/ContentItem';
// components
// types
import { ContentEntity } from '@/types/schema';

function ContentItemContainer({
  content,
  onDelete,
}: {
  content: ContentEntity;
  onDelete?: (childResourceId: string) => void;
}) {
  const { t } = useTranslation();
  const _onDelete = useCallback(() => onDelete?.(content.id), [onDelete, content.id]);

  return (
    <Stack className="group w-full px-4">
      <Stack alignItems="center" className="content w-full truncate pe-12" justifyContent="between">
        <ContentItem content={content} />
        <Tooltip placement="right" title={t('Feedback:CreateFeedback.RemoveContent')}>
          <LinkButton
            className="flex-shrink-0 py-2 px-4 opacity-0 transition duration-150 ease-linear group-hover:opacity-100"
            color={'internal'}
            onClick={_onDelete}>
            <Close />
          </LinkButton>
        </Tooltip>
      </Stack>
    </Stack>
  );
}

export default ContentItemContainer;
